import styled from 'styled-components';

export const GameCard = styled.section`
max-width:500px;
max-height: 400px;
position: absolute;
margin: auto;
left: 0;
right: 0;
top: 0;
bottom: 0;
padding: 20px;
text-align: center;
color: #fff;
font-family: 'Philosopher', sans-serif;
`